import type { TCardVariant } from '@cascade/ui-library';

export const getOptionCardVariant = (
  isSelected: boolean,
  isRecommended: boolean,
): TCardVariant | undefined => {
  if (isSelected) {
    return 'info';
  }

  if (isRecommended) {
    return 'success';
  }

  return undefined;
};

export const toOptionIds = (choice: string | string[]): string[] =>
  Array.isArray(choice) ? choice : [choice];

export const toggleOption = (
  optionIds: string[],
  optionId: string,
  isMultiple: boolean,
): string[] => {
  if (!isMultiple) {
    return [optionId];
  }

  if (optionIds.includes(optionId)) {
    return optionIds.filter((selectedId) => selectedId !== optionId);
  }

  return [...optionIds, optionId];
};
